/**
 * Revenue Timeline Chart
 *
 * Area chart showing monthly revenue over time.
 */

import ChartContainer from '@/components/charts/ChartContainer';
import AreaChart from '@/components/charts/AreaChart';
import type { MonthlyRevenue } from '../types';

interface RevenueTimelineChartProps {
  data?: MonthlyRevenue[];
  loading?: boolean;
}

function formatMonth(month: string): string {
  const [year, m] = month.split('-');
  const date = new Date(parseInt(year), parseInt(m) - 1);
  return date.toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
}

export function RevenueTimelineChart({ data, loading }: RevenueTimelineChartProps) {
  const chartData = data?.map((item) => ({
    name: formatMonth(item.month),
    invoices: item.invoice_revenue,
    projects: item.project_revenue,
  })) ?? [];

  const hasData = chartData.length > 0 && chartData.some((d) => d.invoices > 0 || d.projects > 0);

  return (
    <ChartContainer
      title="Revenue Over Time"
      loading={loading}
      height={300}
    >
      {hasData ? (
        <AreaChart
          data={chartData}
          height={300}
          xAxisKey="name"
          series={[
            { dataKey: 'invoices', name: 'Invoice Revenue', color: '#3b82f6' },
            { dataKey: 'projects', name: 'Project Revenue', color: '#22c55e' },
          ]}
          showLegend
          stacked
        />
      ) : (
        <div className="flex items-center justify-center h-full text-muted-foreground text-sm">
          No revenue data available
        </div>
      )}
    </ChartContainer>
  );
}
